import React from 'react';
import SectionMessage from '@atlaskit/section-message/section-message';
import SectionMessageAction from '@atlaskit/section-message/section-message-action';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import type { HealthcheckSuggestedActionLink } from './HealthcheckSuggestedActionLink.types.tsx';

const HealthcheckSuggestedAction = (props: {
	error: string;
	action: string | null;
	link: HealthcheckSuggestedActionLink | null;
}): React.JSX.Element => {
	const actions = props.link
		? [
				<SectionMessageAction key="action" href={props.link.link}>
					{props.link.name}
				</SectionMessageAction>,
			]
		: [];

	return (
		<>
			<SectionMessage title="Step Failed" appearance="error" actions={actions}>
				<Stack space="space.100">
					<Text>{props.error}</Text>
					<Text>{props.action}</Text>
				</Stack>
			</SectionMessage>
		</>
	);
};

export default HealthcheckSuggestedAction;
